// Importare i moduli
// import './modules/nomemodulo';
import './modules/nav';
import './modules/what';
import './modules/lavoro';
import './modules/realizzazioni';

// Rimuovi no-js
document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/,'js');
